const DEFINE = {
  BRIDGE: {
    ROUTER: {
      // 1(홈),2(스토어),3(장바구니),4(내 정보)(Type : String)
      1: {name: 'Home'},
      2: {name: 'Store'},
      3: {name: 'Basket'},
      4: {name: 'MyPage'},
      5: {name: 'ViewLog'},
      6: {name: 'Login'}
    }
  },

  DEFAULT: {
    BROADCAST: {
      THUMBNAIL: '/static/images/default_thumbnail.png'
    }
  },

  JOINTYPE: {
    0: window.$i18n?.locale !== 'ko' ?  process.env.VUE_APP_SERVICE_NAME_KO : process.env.VUE_APP_SERVICE_NAME_EN,
    1: 'mypage.kakao',
    2: 'mypage.naver',
    3: 'mypage.google',
    4: 'mypage.facebook'
  }
}

export default DEFINE;
